/**
 * Faixa "Equipe agora": quem trabalha no setor e o que cada um está fazendo
 * (o balão do jogo). Tocar na pessoa filtra a tela por ela; tocar de novo
 * tira o filtro.
 */
import React from "react";

import { primeiroNome } from "./modelo";
import { FaixaEquipe, Pessoa } from "./styles";
import { AvatarPessoa } from "./ui";

export default function Equipe({ colaboradores, atividades, selecionados, onAlternar, onCadastrar }) {
  return (
    <FaixaEquipe aria-label="Equipe do setor">
      <span className="rotulo">Equipe agora</span>
      {colaboradores.length === 0 ? (
        <span className="vazio">
          Nenhum colaborador neste setor. Cadastre quem trabalha aqui para ver, ao vivo, o que cada um está
          fazendo.
          {onCadastrar && (
            <>
              {" "}
              <button type="button" className="btn btn--secondary btn--sm" onClick={onCadastrar}>
                Cadastrar colaborador
              </button>
            </>
          )}
        </span>
      ) : (
        colaboradores.map((c) => {
          const atividade = atividades.get(c.id);
          const ativa = selecionados.includes(c.id);
          return (
            <Pessoa
              key={c.id}
              type="button"
              $ativa={ativa}
              aria-pressed={ativa}
              data-estado={atividade?.estado}
              title={`${c.nome}: ${atividade?.texto || "sem atividade"}`}
              onClick={() => onAlternar(c.id)}
            >
              <AvatarPessoa
                nome={c.nome}
                tom={atividade?.tom || "neutral"}
                trabalhando={atividade?.estado === "trabalhando"}
              />
              <span className="texto">
                <span className="nome">{primeiroNome(c.nome)}</span>
                <span className="fazendo">{atividade?.texto || "Sem atividade apontada"}</span>
              </span>
            </Pessoa>
          );
        })
      )}
    </FaixaEquipe>
  );
}
